import { UnregisterCallback } from 'history';
import { weappSDK } from "../sdk";
import history from "../history-plugin/history";
import H5Title, { H5TitleType } from './H5Title';
import { ua } from '../ua'
import { getSyncHook } from '../js-api-tools';
const patt = /\$(user|department)Name=(.*?)\$/g;

export const replaceWechatStr = (str: string) => {
  if (!str) {
    return str;
  }
  // 判断是否在企业微信环境
  if (/wxwork/.test(ua.browser)) {
    return str.replace(patt, '');
  } else {
    return str;
  }
};

export class DocumentTitle {

  private event: string = 'popstate';

  private unlistener: UnregisterCallback | undefined;

  /* 页面初始时的title */
  private originDocumentTitle: string;

  /* 记录各个地址对应的title */
  private locationMap = new Map<string, string>();

  h5Title: H5TitleType = new H5Title();
  constructor() {
    // 页面加载时初始化监听器
    this.addListener();
    // 记录页面原始的title
    this.originDocumentTitle = window.document.title;
    window?.TEAMS?.ready?.('TEAMS', {
      success: () => {
        this.h5Title?.registerH5Title();
      },
    })
  }

  getCurrLocation = () => {
    return window.location.host + window.location.pathname;
  }

  getMachedTitle = (currLocation: string) => {
    let matchedTitle = this.locationMap.get(currLocation) || '';
    if (!matchedTitle) {
      let nearLocation = '';
      const locations = this.locationMap.keys();
      let location: IteratorResult<string, any>;
      // 找到与当前location最相近的记录
      while (!(location = locations.next()).done) {
        if (currLocation.indexOf(location.value) === 0 && location.value.length > nearLocation.length) {
          nearLocation = location.value;
        }
      }
      matchedTitle = this.locationMap.get(nearLocation) || this.originDocumentTitle;
    }
    return matchedTitle;
  }

  hashChangeHandler = () => {
    const currLocation = this.getCurrLocation();
    const machedTitle = this.getMachedTitle(currLocation);
    if (machedTitle) { // 避免空title的情况
      weappSDK.setTitle({ title: machedTitle });
    }
    this.h5Title?.registerH5Title();
  }

  addListener = () => {
    // window.addEventListener(this.event, this.hashChangeHandler);
    history.listen(this.hashChangeHandler);
  }

  removeListener = () => {
    // window.removeEventListener(this.event, this.hashChangeHandler);
    this.unlistener?.();
    this.h5Title?.unRegisterH5Title();
  }

  setTitle = (params: any) => {
    const hooks = getSyncHook('@weapp/utils', 'setTitle');
    if (hooks) {
      params = hooks(params);
    }
    const currLocation = params?.currLocation || this.getCurrLocation();
    if (params?.title) {
      params.title = replaceWechatStr(params.title);
    }
    this.locationMap.set(currLocation, params?.title || this.originDocumentTitle);
    weappSDK.setTitle(params);
    // 更新title
    this.h5Title?.registerH5Title();
  }

  setHorizontal = (isHorizontal?: boolean) => {
    this.h5Title?.unRegisterH5Title()
    this.h5Title?.setHorizontal(isHorizontal)
    this.h5Title?.registerH5Title()
  }
}

const documentTitle = new DocumentTitle();

export default documentTitle;
